/* eslint-disable react/static-property-placement */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/state-in-constructor */
import React from 'react';
import Bugsnag from '@bugsnag/js';

import { bugSnagLog } from '~/utils/bugsnag';

interface ErrorBoundaryProps {
  FallbackComponent: React.ComponentType<{ clearError?: () => void; error?: Error }> | null;
  fallbackText: string | null;
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundaryCustom extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  static defaultProps: Partial<ErrorBoundaryProps> = {
    fallbackText: null,
    FallbackComponent: null,
  };

  state: ErrorBoundaryState = {
    hasError: false,
    error: null,
  };

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.warn('Error Boundary Custom Details', error, info);
    bugSnagLog({
      errorMessage: error.message,
      context: info,
      severity: 'error',
      errorDetails: error,
    });
  }

  clearError = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    const { children, FallbackComponent, fallbackText } = this.props;
    const { hasError, error } = this.state;
    if (hasError) {
      return FallbackComponent ? (
        <FallbackComponent clearError={this.clearError} error={error} />
      ) : (
        fallbackText
      );
    }

    return children;
  }
}

const ErrorBoundary =
  process.env.NEXT_PUBLIC_BUGSNAG_ENABLED === 'true' && !!Bugsnag.getPlugin('react')
    ? Bugsnag.getPlugin('react').createErrorBoundary(React)
    : ErrorBoundaryCustom;

export default ErrorBoundary;
